<template>
    <div class="container">
        <Stats/>
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
import Stats from '@/components/overview/Stats.vue'

export default {
    name: 'Overview',
    components: {
    Stats,
  },
}
</script>